export const CLASSES_TO_SKIP_INVERT_COLORS = ['pricingSnippet'];
